<template>
  <aside>
    <slide-in-overlay
      :is-open="isOpen"
      max-width="721px"
      @close="closeForm"
      class="o-contactform"
    >
      <template v-slot:body>
        <h1>{{ title }}</h1>

        <div class="o-contactform__trumpet">
          {{ trumpet }}
        </div>

        <slot name="urgent" v-if="!success"></slot>

        <h3>{{ translations["Subject"] }}</h3>

        <div class="o-contactform__subjects">
          <div class="o-contactform__subject">
            <input
              id="subject_support"
              name="subject"
              type="radio"
              value="Support & Information"
              v-model="subject"
            />
            <label for="subject_support">
              <subject-support />
              {{ translations["Support & Information"] }}
            </label>
          </div>
          <div class="o-contactform__subject">
            <input
              id="subject_development"
              name="subject"
              type="radio"
              value="Development"
              v-model="subject"
            />
            <label for="subject_development">
              <subject-development />
              {{ translations["Development"] }}
            </label>
          </div>
          <div class="o-contactform__subject">
            <input
              id="subject_training"
              name="subject"
              type="radio"
              value="Training & Service"
              v-model="subject"
            />
            <label for="subject_training">
              <subject-training />
              {{ translations["Training & service"] }}
            </label>
          </div>
        </div>

        <h3>{{ translations["Contact information"] }}</h3>
        <input type="hidden" name="action" value="contact-form/send" />
        <div class="o-fieldsgrid">
          <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--half">
            <input
              type="text"
              id="fromName"
              class="w-full validate input"
              :class="{ valid: fromName }"
              name="fromName"
              required="required"
              v-model="fromName"
            />
            <label for="fromName">
              {{ translations["Name of contact"] }}*
            </label>
          </div>

          <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--half">
            <input
              type="text"
              id="contactCompany"
              class="w-full validate input"
              :class="{ valid: company }"
              name="message['company']"
              required="required"
              v-model="company"
            />
            <label for="contactCompany"> {{ translations["Company"] }}* </label>
          </div>

          <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--half">
            <input
              type="text"
              id="contactEmail"
              class="w-full validate input"
              :class="{ valid: fromEmail }"
              name="fromEmail"
              required="required"
              v-model="fromEmail"
            />
            <label for="contactEmail"> {{ translations["E-mail"] }}* </label>
          </div>

          <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--half">
            <input
              type="text"
              id="contactphone"
              class="w-full validate input"
              :class="{ valid: phone }"
              name="phone"
              required="required"
              v-model="phone"
            />
            <label for="contactphone"> {{ translations["Phone"] }}* </label>
          </div>

          <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--full">
            <textarea
              rows="10"
              cols="40"
              id="message"
              :class="{ valid: message }"
              name="message[comment]"
              v-model="message"
            ></textarea>
            <label for="message">
              {{ translations["Comment"] }}
            </label>
          </div>
        </div>
        <div
          tabindex="-1"
          aria-hidden="true"
          style="position: fixed; left: -100%; top: -100%"
        >
          <label
            for="50d642e8-add6-4cd0-aa23-0341da07a60c"
            aria-hidden="true"
            tabindex="-1"
          ></label>
          <input
            type="text"
            name="form_company"
            value=""
            id="50d642e8-add6-4cd0-aa23-0341da07a60c"
            tabindex="-1"
            aria-hidden="true"
            v-model="form_company"
          />
        </div>

        <div class="o-btn o-btn--filled" @click="submitForm()">
          {{ translations["Send request"] }}
        </div>

        <div class="o-contactform__term">
          <clock-icon />{{
            translations["We strive to respond to your request within 24 hours"]
          }}
        </div>

        <transition name="fade">
          <div class="o-contactform__loader" v-if="isSubmitting">
            <slot name="loader" v-if="!success"></slot>
            <slot name="success" v-if="success"></slot>
          </div>
        </transition>
      </template>
    </slide-in-overlay>

    <sticky-contact
      v-if="!isOpen"
      :title="title"
      :text="translations['Send us your request']"
      @please-open="slideOut"
    />
  </aside>
</template>


<script>
import StickyContact from "../components/StickyContact.vue";
import SlideInOverlay from "../components/SlideInOverlay.vue";
import ClockIcon from "-!vue-svg-loader!../../images/icon-clock.svg";
import PhoneIcon from "-!vue-svg-loader!../../images/icon-phone.svg";
import SubjectSupport from "-!vue-svg-loader!../../images/subject-support.svg";
import SubjectDevelopment from "-!vue-svg-loader!../../images/subject-development.svg";
import SubjectTraining from "-!vue-svg-loader!../../images/subject-training.svg";

import axios from "axios";
import { trackStickyContactSubmit } from "../scripts/tag-manager";

export default {
  name: "ContactForm",
  components: {
    StickyContact,
    SlideInOverlay,
    ClockIcon,
    PhoneIcon,
    SubjectSupport,
    SubjectDevelopment,
    SubjectTraining,
  },
  props: {
    title: String,
    trumpet: String,
    csrf: String,
    translations: Object,
    todayOpen: {
      type: String,
      default: "",
    },
    todayClose: {
      type: String,
      default: "",
    },
    directPhone: {
      type: String,
      default: "hide",
    },
    mainPhone: {
      type: String,
      default: "empty",
    },
  },
  data: () => ({
    showCompany: false,
    showPhone: false,
    fromName: null,
    fromEmail: null,
    company: null,
    phone: null,
    message: null,
    subject: null,
    form_company: null, //Form honeypot
    submitStatus: null,
    isSubmitting: false,
    success: false,
    error: false,
    isOpen: false,
  }),
  computed: {
    contactText() {
      return this.firstContact.text.length > 220
        ? `${this.firstContact.text.substring(0, 220)}...`
        : this.firstContact.text;
    },
    isOpenToday() {
      if (this.todayOpen != "") {
        return true;
      } else {
        return false;
      }
    },
    displayPhone() {
      if (this.directPhone === "show") {
        if (this.firstContact.phone !== "") {
          return this.firstContact.phone;
        } else {
          return this.mainPhone;
        }
      } else {
        return this.mainPhone;
      }
    },
  },
  methods: {
    async submitForm() {
      if (this.form_company || !this.subject) {
        return;
      }

      const formData = new FormData();
      formData.append("fromName", this.company + ", " + this.fromName);
      formData.append("fromEmail", this.fromEmail);
      formData.append("subject", this.subject ? this.subject : "");
      formData.append("message[phone]", this.phone ? this.phone : "");
      formData.append("message[comment]", this.message ? this.message : "");
      formData.append(
        "message[formName]",
        this.subject ? this.subject : "Contact"
      );

      this.sendEmail(formData);
    },
    sendEmail(formData) {
      this.isSubmitting = true;
      formData.append("action", "contact-form/send");
      formData.append("CRAFT_CSRF_TOKEN", this.csrf);

      axios
        .post(document.location.href, formData)
        .then((result) => {
          console.log(result.success);
          if (result.data.success) {
            this.submitStatus = "success";
            this.error = false;
            this.success = true;
            this.fromName = null;
            this.fromEmail = null;
            this.company = null;
            this.phone = null;
            this.message = null;
            this.subject = null;
            this.success = true;
            trackStickyContactSubmit();
          }

          if (result.data.errors) {
            this.error = true;
            this.success = false;
            this.submitStatus = "error";
            this.isSubmitting = false;
          }
        })
        .catch((e) => {
          this.submitStatus = "error";
          this.error = true;
          console.log(e);
        })
        .then(() => {
          setTimeout(() => {
            this.isSubmitting = false;
            this.success = false;
          }, 1800);
        });
    },
    closeForm() {
      if (this.isSubmitting) {
        return;
      }

      this.$emit("close");
      this.isOpen = false;
      this.showCompany = false;
      this.showPhone = false;
      this.name = null;
      this.email = null;
      this.company = null;
      this.phone = null;
      this.message = null;
      this.success = false;
      this.error = false;
    },
    slideOut() {
      this.$emit("open");
      this.isOpen = true;
    },
  },
  created() {},
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";

.o-contactform {
  &__trumpet {
    margin-bottom: 30px;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
  }

  &__urgent {
    display: flex;
    margin-bottom: 33px;
    background: #eef7ec;
    border: 1px solid #57b446;

    &-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 9px;
      background: #57b446;
    }

    &-content {
      padding: 18px 18px 8px;
      font-size: 16px;
      line-height: 16px;
      color: #5d5c5c;
    }

    &-contact {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 9px;

      .phone {
        margin-right: 10px;
        margin-bottom: 10px;
        font-size: 18px;
        line-height: 20px;
        color: #172642;
        font-weight: 700;
      }

      .time {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        font-size: 16px;
        line-height: 16px;
        color: #57b446;
        margin-bottom: 10px;
        span {
          margin-right: 5px;
        }
      }
    }

    &--closed {
      border-color: #c54848;
      background: #f7eced;
      .o-contactform__urgent {
        &-icon {
          background: #c54848;
        }
        &-content {
        }
        &-contact {
          .time {
            color: #c54848;
          }
        }
      }
    }
  }

  &__subjects {
    display: flex;
    justify-content: space-between;
    margin-bottom: 39px;
  }

  &__subject {
    width: calc(33.333% - 6px);

    label {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 19px 20px 10px;
      border: 1px solid #b9b9b9;
      text-align: center;
      font-size: 10px;
      line-height: 15px;
      font-weight: 700;
      transition: all 0.3s $t-nice;
    }

    svg {
      margin-bottom: 15px;
      path {
        transition: all 0.3s $t-nice;
      }
    }

    input {
      position: absolute;
      opacity: 0;
      visibility: hidden;
      &:checked + label {
        background: $brand-orange;
        color: #fff;
        border-color: $brand-orange;
        path {
          fill: #fff;
        }
      }
    }

    &:hover {
      cursor: pointer;
      label {
        cursor: pointer;
        border-color: $brand-orange;
      }
    }
  }

  &__loader {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.8);
  }

  &__term {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 13px;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    svg {
      min-width: 20px;
      margin-right: 6px;
    }
  }

  &__fields {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__field {
    margin-bottom: 11px;
  }

  .o-btn {
    display: flex;
    justify-content: center;
    margin-top: 2px;
    width: 100%;
    font-size: 18px;
    line-height: 16px;
    text-align: center;
  }

  h1 {
    color: $brand-dark-blue;
    font-size: 36px;
    line-height: 42px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
  }

  h3 {
    margin-bottom: 25px;
    color: $brand-dark-blue;
    font-size: 22px;
    text-align: center;
    line-height: 22px;
    font-weight: 400;
    text-transform: uppercase;
  }
}

@media all and (max-width: 449px) {
  .o-contactform {
    &__subjects {
      flex-direction: column;
    }

    &__subject {
      width: 100%;
      margin-bottom: 15px;
    }
  }
}
</style>
